// =============================================
// COMPONENTE: DatabaseNode - Nó de Ação no Banco
// =============================================
// Arquivo: DatabaseNode.tsx
// Descrição: Nó para executar ações diretas no banco de dados
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Database, Settings, Search, Trash2 } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const DatabaseNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, dbAction, table, description, actions } = data;

  const getActionIcon = () => {
    switch (dbAction) {
      case 'insert':
        return <Settings size={14} />;
      case 'update':
        return <Settings size={14} />;
      case 'delete':
        return <Trash2 size={14} />;
      case 'select':
        return <Search size={14} />;
      default:
        return <Database size={14} />;
    }
  };

  const getActionText = () => {
    const actions: Record<string, string> = {
      insert: 'Inserir',
      update: 'Atualizar',
      delete: 'Deletar',
      select: 'Buscar'
    };
    const actionText = dbAction ? actions[dbAction] || 'Ação' : 'Ação';
    return table ? `${actionText} em ${table}` : actionText;
  };

  return (
    <div className={`flow-node database-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="flow-handle"
      />

      <div className="node-header database-header">
        <Database className="node-icon" size={18} />
        <span className="node-title">{label || 'Banco de Dados'}</span>
      </div>

      <div className="node-body">
        <div className="node-detail">
          {getActionIcon()}
          <span className="node-detail-text">{getActionText()}</span>
        </div>
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="flow-handle"
      />
    </div>
  );
};

export default DatabaseNode;
